import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './PropertyAttribute.scss';

const attributeLabels = {
  beds: 'Bedrooms',
  baths: 'Bathrooms',
  carSpaces: 'Car spaces',
  floorSize: 'Floor area',
  landSize: 'Land area',
};

const landSizeUnitList = {
  hectare: 'ha',
  acre: 'ac',
  square: 'sq',
  squareMeter: <span>m<sup>2</sup></span>,
};

class PropertyAttribute extends Component {
  render() {
    let { value } = this.props;

    if (isNaN(value)) {
      value = '-';
    }

    return (
      <div className="d-flex align-items-center" title={attributeLabels[this.props.type] || ''}>
        <div className={`icon mr-2 ${styles[this.props.type]} ${this.props.gray ? styles.gray : ''}`}></div>
        <div><span data="seoData">{attributeLabels[this.props.type]}: </span>{value}
          {(value != '-' && (this.props.type == 'floorSize' || this.props.type == 'landSize')) ?
            this.props.unit ? landSizeUnitList[this.props.unit] :
              <span>m<sup>2</sup></span> : null}
        </div>
      </div>
    );
  }
}

PropertyAttribute.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.string,
  gray: PropTypes.bool,
};

export default PropertyAttribute;
